import { clientRequest } from "./client";

import { MosaicChatAgent } from "../types/entities";

export const deleteThread = async ({
  threadId,
  agentId
}: {
  threadId: string;
  agentId: MosaicChatAgent;
}) => {
  return clientRequest(async client => {
    return client.deleteThread(threadId, { agentId });
  });
};
